import { AssetColumns } from "~/modules/assets/types";
import { ColumnMetadata, ColumnTypes } from "~/components/DataGrid";
import { AssetTableRowData } from "../types";

// // // //

export const ASSET_TO_PEGGED_ASSET_RATIO_COLUMN: ColumnMetadata<
    AssetTableRowData,
    AssetColumns
> = {
    slug: AssetColumns.assetToPeggedAssetRatio,
    label: "Asset to Pegged Asset Ratio",
    type: ColumnTypes.number,
    sortsOn: AssetColumns.assetToPeggedAssetRatio,
    width: 175,
    cellValue: (item) => {
        if (item.isAsset) {
            if (!item.asset_to_pegged_asset_ratio) return null;

            return item.asset_to_pegged_asset_ratio;
        }

        return null;
    },
};
